import {API, Auth} from 'aws-amplify';
import * as AWS from 'aws-sdk';
import LogRocket from "logrocket";

function getMyInitiDocumentDb(report_id) {
    let myInitDb = {
        body: {
            database: 'db-pipeline',
            collection: 'report-embarcado',
            command: 'find_one',
            query: {
                client: "" + process.env.REACT_APP_X_TENANT_ID + "",
                report_id: "" + report_id + ""
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDash(email, client, dashID, regionID, accessKeyId, secretAccessKey, sessionToken) {

    let myInitDb = {
        body: {
            "email": email ? email : 'qa@domrock.ai',
            "clientName": client,
            "dashboardId": dashID,
            "dashboardRegion": regionID,
            "resetDisabled": false,
            "undoRedoDisabled": false,
            "accessKeyId": accessKeyId,
            "secretAccessKey": secretAccessKey,
            "sessionToken": sessionToken
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    //  console.log(myInitDb);
    return myInitDb;
}


export default {


    getPanel: (report_id = {}) => {

        let coginito_quick = String(process.env.REACT_APP_COGINITO_USER_POOL_ID_QUICKSIGHT);
        let options = {
            IdentityPoolId: process.env.REACT_APP_COGINITO_IDENTITY_POOL_ID,
            Logins: {
                [coginito_quick]: localStorage.getItem('token')
            }
        };

        AWS.config.credentials = new AWS.CognitoIdentityCredentials(options, {region: process.env.REACT_APP_REGION});
        AWS.config.credentials.clearCachedId();
        return AWS.config.credentials.getPromise().then(response =>
            API.post('dr', '/getembededurl', getMyInitiDash(localStorage.tbClientes, process.env.REACT_APP_ARMEN_THEME, report_id, process.env.REACT_APP_REGION, AWS.config.credentials.accessKeyId, AWS.config.credentials.secretAccessKey, AWS.config.credentials.sessionToken))
        ).then(resp => {
            return resp.EmbedUrl;
        }).catch(erro => {
            LogRocket.captureException(erro);
            alert(erro);
        })

        //return 'https://us-east-1.quicksight.aws.amazon.com/embed/9b018318b927480ab7cdce6e1c67e159/dashboards/ebcb3d60-16ea-4b7c-8010-32030902a753?code=AYABeHmOEcdiWcBwRNWshdJZ9wMAAAABAAdhd3Mta21zAEthcm46YXdzOmttczp1cy1lYXN0LTE6MjU5NDgwNDYyMTMyOmtleS81NGYwMjdiYy03MDJhLTQxY2YtYmViNS0xNDViOTExNzFkYzMAuAECAQB4ZGLViwIvMWeq0eg2SdOyWJS86qkEBfgLEiY79AhlHtMBZ4D2LjTs5JUFVF9YzrD8IQAAAH4wfAYJKoZIhvcNAQcGoG8wbQIBADBoBgkqhkiG9w0BBwEwHgYJYIZIAWUDBAEuMBEEDKb1Thi0suzeoo3qzwIBEIA7C-k4eCMWttcu-L9BLvaFhLGTy9RxGCdwsFmDzM-csErJyr5dXV0CugngaWMcRwCi6JdISxbKj3TSvZUCAAAAAAwAABAAAAAAAAAAAAAAAAAA2gDM97z3UG9HD6RZDEinWv____8AAAABAAAAAAAAAAAAAAABAAAA5SM9CD7jIS_ZYggZfvtH03rZeSGyJI-f7Q-Fx5_yuEMtyQh5hbgRQOJerPk6pBjMZkE2EagSMh9BYDVWcH0IztH9gEr-GxTpdb4M-yXxhWf5JBv1JqO-6buqX4-DqLI_tsiPZkVooJdBcHnFE62koasx9STDB7RyNZjya8OkbbLsc2JHTYxgHmBdTcmHvITyhfA0H20Pz6XIDSm2jwKu0awivANbWSoAGsbtEP2jsC6s4kxnXv4tIKNbE6ZymyENA8LqPxEHIOB6cF-XY3uyQAQHssn7PgqG_GgUeodyykD9TBkwgTrMT6QdTBimIvYPSWT_grq6&identityprovider=quicksight&isauthcode=true';
    },
    getPanelIdMongo: (report_id) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb(report_id)).then(response => {
            return response.response;
        }),
};
